import { Skeleton } from '@yakit/ui-components';
import { lazy, Suspense } from 'react';

const HeaderMF = lazy(async () => import('header/HeaderProvider'));

export const HeaderMFWrapper = () => {
  return (
    <div>
      <Suspense fallback={<Skeleton className="h-[6.25rem] w-full" />}>
        <HeaderMF
          id={8007}
          name="Показатели оценки эффективности деятельности высших должностных лиц"
          baseURL="https://vdl.yakit.pro/apiusers"
          tokenKey={'token_yakit'}
          apiKey={
            import.meta.env.DEV ? import.meta.env.VITE_API_KEY : undefined
          }
          includesBreadCrumbs={false}
          includesMenu={false}
          includesUserMenu={false}
        />
      </Suspense>
    </div>
  );
};
